export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ZoomButton.vue?vue&type=template&id=68445575&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./src/uScope/js/extensions/zoom/ZoomButton.vue?vue&type=template&id=68445575&scoped=true&
// module id = 527
// module chunks = 0